import React, { createContext, useReducer } from 'react';
import reducer, { initialState } from './reducers/single-shift.reducer';

const SingleShiftStateContext = createContext(null);
const SingleShiftDispatchContext = createContext(null);

function SingleShiftProvider({ children }) {
  const [state, dispatch] = useReducer(reducer, initialState, undefined);

  return (
    <SingleShiftStateContext.Provider value={state}>
      <SingleShiftDispatchContext.Provider value={dispatch}>{children}</SingleShiftDispatchContext.Provider>
    </SingleShiftStateContext.Provider>
  );
}

export { SingleShiftProvider, SingleShiftStateContext, SingleShiftDispatchContext };
